<template>
  <component
    :is="tag"
    v-if="html"
    v-bind="domProps"
    :class="elementClass"
    :style="elementStyle"
    v-html="html"
  />
  <component
    :is="tag"
    v-else
    v-bind="domProps"
    :class="elementClass"
    :style="elementStyle"
  >
    {{ text }}
    <template
      v-for="(slotNodes, slotName) in nestedSlots"
      #[slotName]
      :key="slotName"
    >
      <SlotElement
        v-for="(slotChild, slotChildIndex) in slotNodes"
        :key="slotChildIndex"
        :element="slotChild"
      />
    </template>
    <SlotElement
      v-for="(child, childIndex) in children"
      :key="childIndex"
      :element="child"
    />
  </component>
</template>

<script>
import { defineAsyncComponent } from "vue";
import { slotElementProps, slotElementText } from "@/helpers/content.js";

export default {
  name: "SlotElement",
  props: {
    element: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      asyncComponent: null,
    };
  },
  computed: {
    tag() {
      if (this.element.tag) return this.element.tag;
      if (this.asyncComponent) return this.asyncComponent;
      return "span";
    },
    nestedSlots() {
      return this.element.slot || {};
    },
    html() {
      if (typeof this.element.html === "string") {
        return this.element.html;
      }
      if (typeof this.element.props?.html === "string") {
        return this.element.props.html;
      }
      return null;
    },
    text() {
      return slotElementText(this.element);
    },
    domProps() {
      return slotElementProps(this.element);
    },
    elementClass() {
      return this.element.class;
    },
    elementStyle() {
      return this.element.style;
    },
    children() {
      return Array.isArray(this.element.children) ? this.element.children : [];
    },
  },
  created() {
    if (this.element.tag || !this.element.component) return;

    const componentPath = this.element.component;
    this.asyncComponent = defineAsyncComponent(() =>
      import(
        /* webpackChunkName: "[request]" */ `@/components/${componentPath}.vue`
      )
    );
  },
};
</script>
